// من أي إشعار أذكار فُتح التطبيق؟
//
// أندرويد: النيّة تصل MainActivity قبل أن تجهز الصفحة، فيحفظها المُلحق
// والصفحة تسأل. iOS: LocalNotifications يبلّغ بالضغط مباشرة.

import { isAthkarCategory } from '../data/athkarData';

const plugins = () => window.Capacitor?.Plugins ?? {};

export async function consumeAthkarLaunch() {
  const adhan = plugins().Adhan;
  if (!adhan?.consumeLaunchAthkar) return null;
  try {
    const { category } = (await adhan.consumeLaunchAthkar()) ?? {};
    return isAthkarCategory(category) ? category : null;
  } catch {
    return null;
  }
}

/**
 * أندرويد: الضغط على إشعار والتطبيق أمامي لا يُطلق visibilitychange،
 * فيرسل المُلحق إشارة ليسأل الموقع عن الفئة المحفوظة.
 * @returns {() => void} يوقف الاستماع
 */
export function listenAthkarLaunch(onSignal) {
  const adhan = plugins().Adhan;
  if (!adhan?.addListener) return () => {};

  const sub = Promise.resolve(adhan.addListener('athkarLaunch', () => onSignal())).catch(() => null);

  return () => {
    sub.then((s) => s?.remove?.());
  };
}

/** @returns {() => void} يوقف الاستماع */
export function listenAthkarTaps(onOpen) {
  const ln = plugins().LocalNotifications;
  if (!ln?.addListener) return () => {};

  // Promise.resolve: الوكيل الأصلي يُرجع thenable بلا catch
  const sub = Promise.resolve(
    ln.addListener('localNotificationActionPerformed', (action) => {
      const category = action?.notification?.extra?.athkar;
      if (isAthkarCategory(category)) onOpen(category);
    })
  ).catch(() => null);

  return () => {
    sub.then((s) => s?.remove?.());
  };
}
